import { render } from "./CategoriasNav.vue?vue&type=template&id=4b9c9ece&scoped=true"
import script from "./CategoriasNav.vue?vue&type=script&lang=js"
export * from "./CategoriasNav.vue?vue&type=script&lang=js"

import "./CategoriasNav.vue?vue&type=style&index=0&id=4b9c9ece&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9c9ece"]])

export default __exports__